/* eslint-disable react/no-unknown-property */
///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/apps/task/Agent/Components/CopilotButton"/>
import { CopilotImage } from "Core/Medius.Core.Web/Scripts/Medius/apps/task/Agent/images/CopilotImage";
import * as React from "react";

interface ICopilotButtonProps {
    onClick: () => void,
    label: string,
    "data-testid": string,
    isMainCopilotButton: boolean,
    disabled?: boolean;
}

export function CopilotButton(props: ICopilotButtonProps) {
    const styles = props.isMainCopilotButton ? 
        {} : 
        { border: "1px solid #0E70C6", margin: "5px", color: "#0E70C6", padding: "0px 8px" };
    return ( 
        <button 
            data-testid={props["data-testid"]}
            onClick={props.onClick}
            disabled={props.disabled}
            className={`copilotButton${props.isMainCopilotButton ? " animate" : ""}`}
            style={styles}
            close-ai-agent-modal="false"
        >
            <CopilotImage close-ai-agent-modal="false"/>
            <span style={props.isMainCopilotButton ? {} : { fontSize: "13px" }} close-ai-agent-modal="false">
                {props.label}
            </span>
        </button>
    );
}